import { type CommonAction, success } from "@iflyrpa/share";
import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";
import { getBaijiahaoData } from "./getBjhInfo";
import { getToutiaoData } from "./getTTInfo";
import { getWeixinData } from "./getWxInfo";
import { getXiaohongshuData } from "./getXhsInfo";
import { bjhConfigData, ttConfigData, wxConfigData, xhsConfigData } from "./types";

export const SearchAccountInfoParamsSchema = ActionCommonParamsSchema.extend({
    token: z.union([z.string(), z.number()]).optional(),
    platform: z.enum(["toutiao", "xiaohongshu", "weixin", "baijiahao"]),
});

export type SearchAccountInfoParams = z.infer<typeof SearchAccountInfoParamsSchema>;

export const SearchAccountInfo: CommonAction<
    SearchAccountInfoParams,
    ttConfigData | xhsConfigData | wxConfigData | bjhConfigData | null
> = async (_task, params) => {
    const { platform } = params;
    switch (platform) {
        case "toutiao":
            return getToutiaoData(_task, params);
        case "xiaohongshu":
            return getXiaohongshuData(_task, params);
        case "weixin":
            return getWeixinData(_task, params);
        case "baijiahao":
            return getBaijiahaoData(_task, params);
        default:
            return success(null, "暂不支持该平台");
    }
};
